import { Component, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { DrawingBasketDto, DrawingEuroPlayoffBaskets, DrawingEuroResultDto, DrawingEuroStageWinnersDto, TeamShortDto } from "app/models";
import { DrawingEuroCountryDto } from "app/models/dtos/drawing-euro-country.dto";
import { DrawingEuroDto } from "app/models/dtos/drawing-euro.dto";
import { DrawingsService } from "app/services";

@Component({
    selector: 'admin-drawing-euro',
    templateUrl: 'drawings-euro.page.html',
    styleUrls: ['../../../../layouts/admin/admin.layout.scss', 'drawings-euro.page.scss'],
})
export class AdminDrawingEuroPage implements OnInit {
    
    euroRatings: DrawingEuroCountryDto[];
    euroData: DrawingEuroDto;

    isLoading: boolean = false;

    stages: any[] = [];

    currentTab: number = 0;

    const;

    drawingResults: DrawingEuroResultDto[];

    stageWinners: DrawingEuroStageWinnersDto[];

    stageLoosers: DrawingEuroStageWinnersDto[];

    prePlayoffBaskets: DrawingEuroPlayoffBaskets;
    pre8Baskets: DrawingEuroPlayoffBaskets;
    pre4Baskets: DrawingEuroPlayoffBaskets;
    pre2Baskets: DrawingEuroPlayoffBaskets;
    finalBaskets: DrawingEuroPlayoffBaskets;

    q1Baskets: DrawingBasketDto[];
    q2Baskets: DrawingBasketDto[];

    lchGroups;
    leGroups;
    lkGroups

    drawnDictionary;
    winnerDictionary;
    loosersDictionary;

    constructor(private drawingsService: DrawingsService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {

        this.buildEuroStagesDictionary();
        this.loadDrawingResults();
        this.loadStageWinners();
        this.loadStageLoosers();
        this.loadPrePlayoffBaskets();
        this.loadData();
    }

    changeTab(tab: number) {
        this.currentTab = tab;
    }

    getMobileMenuLabel(): string {
        if (this.currentTab === 0)
            return "Коэф.";

        for (let i=0; i< this.stages.length; i++) {
            if (this.stages[i].key === this.currentTab)
                return this.stages[i].name;
        }

        return "";
    }

    private loadData() {
        this.isLoading = true;
        this.drawingsService.getEuroRatings()
            .subscribe(result => {
                this.euroRatings = result.countries;
                this.euroData = result;
                this.buildBaskets();
                this.buildGroupBaskets();

                this.isLoading = false;
            });
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages.push({key: CONSTANTS.euroCupStages.qual1, name: CONSTANTS.euroCupStagesNames.qual1});
        this.stages.push({key: CONSTANTS.euroCupStages.qual2, name: CONSTANTS.euroCupStagesNames.qual2});
        this.stages.push({key: CONSTANTS.euroCupStages.group, name: CONSTANTS.euroCupStagesNames.group});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff32, name: CONSTANTS.euroCupStagesNames.playoff32});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff16, name: CONSTANTS.euroCupStagesNames.playoff16});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff8, name: CONSTANTS.euroCupStagesNames.playoff8});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff4, name: CONSTANTS.euroCupStagesNames.playoff4});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff2, name: CONSTANTS.euroCupStagesNames.playoff2});
        this.stages.push({key: CONSTANTS.euroCupStages.final, name: CONSTANTS.euroCupStagesNames.final});
    }

    private buildBaskets() {
        this.q1Baskets=[];
        this.q2Baskets=[];

        let lchQ1 = [];
        let leQ1 = [];
        let lkQ1 = [];

        let lchQ2 = [];
        let leQ2 = [];
        let lkQ2 = [];

        this.euroRatings.forEach(item => {
            item.championsLeague.qual1Teams.forEach(team => {
                lchQ1.push(team);
            });
            item.championsLeague.qual2Teams.forEach(team => {
                lchQ2.push(team);
            });

            item.euroLeague.qual1Teams.forEach(team => {
                leQ1.push(team);
            });
            item.euroLeague.qual2Teams.forEach(team => {
                leQ2.push(team);
            });

            item.conferenceLeague.qual1Teams.forEach(team => {
                lkQ1.push(team);
            });
            item.conferenceLeague.qual2Teams.forEach(team => {
                lkQ2.push(team);
            });
        });

        let lchBaskets = new DrawingBasketDto();
        lchBaskets.basket1 = lchQ1;
        lchBaskets.basket2 = [];

        let leBaskets = new DrawingBasketDto();
        leBaskets.basket1 = leQ1;
        leBaskets.basket2 = [];

        let lkBaskets = new DrawingBasketDto();
        lkBaskets.basket1 = lkQ1;
        lkBaskets.basket2 = [];


        this.q1Baskets[0] = lchBaskets;
        this.q1Baskets[1] = leBaskets;
        this.q1Baskets[2] = lkBaskets;

        if (this.stageWinners) {
            let q1Winners = this.winnerDictionary[CONSTANTS.euroCupStages.qual1];

            q1Winners.championsLeagureWinners.basket1.forEach(item => {
                lchQ2.push(item);
            });

            q1Winners.euroLeagureWinners.basket1.forEach(item => {
                leQ2.push(item);
            });

            q1Winners.confferrenceLeagureWinners.basket1.forEach(item => {
                lkQ2.push(item);
            });
        }

        if (this.stageLoosers) {
            let q1Loosers = this.loosersDictionary[CONSTANTS.euroCupStages.qual1];

            q1Loosers.championsLeagureWinners.basket1.forEach(item => {
                leQ2.push(item);
            });

            q1Loosers.euroLeagureWinners.basket1.forEach(item => {
                lkQ2.push(item);
            });
        }

        let lchBaskets2 = new DrawingBasketDto();
        lchBaskets2.basket1 = lchQ2;
        lchBaskets2.basket2 = [];

        let leBaskets2 = new DrawingBasketDto();
        leBaskets2.basket1 = leQ2;
        leBaskets2.basket2 = [];

        let lkBaskets2 = new DrawingBasketDto();
        lkBaskets2.basket1 = lkQ2;
        lkBaskets2.basket2 = [];


        this.q2Baskets[0] = lchBaskets2;
        this.q2Baskets[1] = leBaskets2;
        this.q2Baskets[2] = lkBaskets2;
    }

    private buildGroupBaskets() {
        this.lchGroups = [];
        this.leGroups = [];
        this.lkGroups = [];

        let allTeams = [];


        //lch prepare
        let lchBasket1 = [];
        let lchBasket2 = [];
        let lchBasket3 = [];
        let lchBasket4 = [];

        lchBasket1.push(this.euroData.lchWinner);
        lchBasket1.push(this.euroData.leWinner);

        allTeams.push(this.euroData.lchWinner);
        allTeams.push(this.euroData.leWinner);

        let countryIndex = 0;
        while (lchBasket1.length < 8) {
            let countryData = this.euroRatings[countryIndex];
            let champion = countryData.championsLeague.groupTeams[0];

            if (!this.isTeamInBasket(lchBasket1, champion.id)) {
                lchBasket1.push(champion);
                allTeams.push(champion);
            }

            countryIndex++;
        }

        let ratingsDictionary = this.euroData.teamsRating;

        let teamsForDrawings = [];

        this.euroRatings.forEach(item => {
            item.championsLeague.groupTeams.forEach(team => {
                if (!this.isTeamInBasket(lchBasket1, team.id)) {
                    let teamRating = {
                        team: team,
                        rating: ratingsDictionary[team.id] ? ratingsDictionary[team.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                }
            })
        });

        if (this.stageWinners) {
            let q2Winners = this.winnerDictionary[CONSTANTS.euroCupStages.qual2];

            q2Winners.championsLeagureWinners.basket1.forEach(winner => {
                if (!this.isTeamInBasket(lchBasket1, winner.id)) {
                    let teamRating = {
                        team: winner,
                        rating: ratingsDictionary[winner.id] ? ratingsDictionary[winner.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                }
            });
        };


        teamsForDrawings.forEach(item => {
            allTeams.push(item);
        });

        teamsForDrawings = teamsForDrawings.sort((a,b) => b.rating - a.rating);


        teamsForDrawings.slice(0, 8).forEach(item => {
            lchBasket2.push(item.team);
        });
        teamsForDrawings.slice(8, 16).forEach(item => {
            lchBasket3.push(item.team);
        });
        teamsForDrawings.slice(16, 24).forEach(item => {
            lchBasket4.push(item.team);
        });

        this.lchGroups[0] = lchBasket1;
        this.lchGroups[1] = lchBasket2;
        this.lchGroups[2] = lchBasket3;
        this.lchGroups[3] = lchBasket4;

        //le prepare
        let leBasket1 = [];
        let leBasket2 = [];
        let leBasket3 = [];
        let leBasket4 = [];

        teamsForDrawings = [];

        this.euroRatings.forEach(item => {
            item.euroLeague.groupTeams.forEach(team => {
                if (!this.isTeamInBasket(allTeams, team.id)) {
                    let teamRating = {
                        team: team,
                        rating: ratingsDictionary[team.id] ? ratingsDictionary[team.id]: 0
                    };
                    
                    teamsForDrawings.push(teamRating);
                }
            })
        });

        if (this.stageWinners) {
            let q2Winners = this.winnerDictionary[CONSTANTS.euroCupStages.qual2];

            q2Winners.euroLeagureWinners.basket1.forEach(winner => {
                if (!this.isTeamInBasket(allTeams, winner.id)) {
                    
                    let teamRating = {
                        team: winner,
                        rating: ratingsDictionary[winner.id] ? ratingsDictionary[winner.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                }
            });
        };

        if (this.stageLoosers) {
            let q2Loosers = this.loosersDictionary[CONSTANTS.euroCupStages.qual2];

            q2Loosers.championsLeagureWinners.basket1.forEach(winner => {
                if (!this.isTeamInBasket(allTeams, winner.id)) {
                    let teamRating = {
                        team: winner,
                        rating: ratingsDictionary[winner.id] ? ratingsDictionary[winner.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                };
            });
        };

        let lkWinner = this.euroData.lkWinner;

        if (lkWinner && !this.isTeamInBasket(allTeams, lkWinner.id)) {
            let teamRating = {
                team: lkWinner,
                rating: ratingsDictionary[lkWinner.id] ? ratingsDictionary[lkWinner.id]: 0
            };

            teamsForDrawings.push(teamRating);
        }

        teamsForDrawings.forEach(item => {
            allTeams.push(item);
        });

        teamsForDrawings = teamsForDrawings.sort((a,b) => b.rating - a.rating);


        teamsForDrawings.slice(0, 8).forEach(item => {
            leBasket1.push(item.team);
        });
        teamsForDrawings.slice(8, 16).forEach(item => {
            leBasket2.push(item.team);
        });
        teamsForDrawings.slice(16, 24).forEach(item => {
            leBasket3.push(item.team);
        });
        teamsForDrawings.slice(24, 32).forEach(item => {
            leBasket4.push(item.team);
        });


        this.leGroups[0] = leBasket1;
        this.leGroups[1] = leBasket2;
        this.leGroups[2] = leBasket3;
        this.leGroups[3] = leBasket4;

        //lk prepare
        let lkBasket1 = [];
        let lkBasket2 = [];
        let lkBasket3 = [];
        let lkBasket4 = [];

        teamsForDrawings = [];

        this.euroRatings.forEach(item => {
            item.conferenceLeague.groupTeams.forEach(team => {
                if (!this.isTeamInBasket(allTeams, team.id)) {
                        let teamRating = {
                            team: team,
                            rating: ratingsDictionary[team.id] ? ratingsDictionary[team.id]: 0
                        };
                        
                        teamsForDrawings.push(teamRating);
                    }
                })
        });

        if (this.stageWinners) {
            let q2Winners = this.winnerDictionary[CONSTANTS.euroCupStages.qual2];

            q2Winners.confferrenceLeagureWinners.basket1.forEach(winner => {
                if (!this.isTeamInBasket(allTeams, winner.id)) {
                    let teamRating = {
                        team: winner,
                        rating: ratingsDictionary[winner.id] ? ratingsDictionary[winner.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                }
            });
        };

        if (this.stageLoosers) {
            let q2Loosers = this.loosersDictionary[CONSTANTS.euroCupStages.qual2];

            q2Loosers.euroLeagureWinners.basket1.forEach(winner => {
                if (!this.isTeamInBasket(allTeams, winner.id)) {
                    let teamRating = {
                        team: winner,
                        rating: ratingsDictionary[winner.id] ? ratingsDictionary[winner.id]: 0
                    };

                    teamsForDrawings.push(teamRating);
                }
            });
        };

        teamsForDrawings = teamsForDrawings.sort((a,b) => b.rating - a.rating);


        teamsForDrawings.slice(0, 8).forEach(item => {
            lkBasket1.push(item.team);
        });
        teamsForDrawings.slice(8, 16).forEach(item => {
            lkBasket2.push(item.team);
        });
        teamsForDrawings.slice(16, 24).forEach(item => {
            lkBasket3.push(item.team);
        });
        teamsForDrawings.slice(24, 32).forEach(item => {
            lkBasket4.push(item.team);
        });


        this.lkGroups[0] = lkBasket1;
        this.lkGroups[1] = lkBasket2;
        this.lkGroups[2] = lkBasket3;
        this.lkGroups[3] = lkBasket4;
    }

    private loadDrawingResults() {
        this.drawingsService.getDrawingEuroResults()
            .subscribe(result => {
                this.drawingResults = result;

                this.drawnDictionary = [];

                result.forEach(item => {
                    this.drawnDictionary[item.stage] = item.drawings;
                })
            })
    }

    private loadStageWinners() {
        this.drawingsService.getEuroStageWinners()
            .subscribe(result => {

                this.stageWinners = result;

                this.winnerDictionary = [];

                result.forEach(item => {
                    this.winnerDictionary[item.stage] = item.winners;
                })

                this.buildPre8Baskets();
                this.buildPre4Baskets();
                this.buildPre2Baskets();
                this.buildFinalBaskets();
            })
    }

    private loadStageLoosers() {
        this.drawingsService.getEuroStageLoosers()
            .subscribe(result => {

                this.stageLoosers = result;

                this.loosersDictionary = [];

                result.forEach(item => {
                    this.loosersDictionary[item.stage] = item.winners;
                })
            })
    }

    private loadPrePlayoffBaskets() {
        this.drawingsService.getPrePlayoffBaskets()
            .subscribe(result => {
                this.prePlayoffBaskets = result;
            })
    }

    private isTeamInBasket(basket: TeamShortDto[], teamId: number) {
        for (let i=0; i<basket.length; i++) {
            let item = basket[i];
            if (item.id == teamId)
                return true;
        }

        return false;
    }

    private buildPre8Baskets() {
        this.pre8Baskets = new DrawingEuroPlayoffBaskets();
        this.pre8Baskets.championsLeagueBasket = new DrawingBasketDto();
        this.pre8Baskets.euroLeagueBasket = new DrawingBasketDto();
        this.pre8Baskets.conferenceLeagueBasket = new DrawingBasketDto();

        if (this.winnerDictionary[CONSTANTS.euroCupStages.group] && this.winnerDictionary[CONSTANTS.euroCupStages.playoff16]) {
            let groupWinners = this.winnerDictionary[CONSTANTS.euroCupStages.group];

            let preWinners = this.winnerDictionary[CONSTANTS.euroCupStages.playoff16];

            this.pre8Baskets.championsLeagueBasket = new DrawingBasketDto();
            this.pre8Baskets.championsLeagueBasket.basket1 = groupWinners.championsLeagureWinners.basket1;
            this.pre8Baskets.championsLeagueBasket.basket2 = groupWinners.championsLeagureWinners.basket2;

            this.pre8Baskets.euroLeagueBasket = new DrawingBasketDto();
            this.pre8Baskets.euroLeagueBasket.basket1 =  groupWinners.euroLeagureWinners.basket1;
            this.pre8Baskets.euroLeagueBasket.basket2 = preWinners.euroLeagureWinners.basket1;

            this.pre8Baskets.conferenceLeagueBasket = new DrawingBasketDto();
            this.pre8Baskets.conferenceLeagueBasket.basket1 =  groupWinners.confferrenceLeagureWinners.basket1;
            this.pre8Baskets.conferenceLeagueBasket.basket2 =  preWinners.confferrenceLeagureWinners.basket1;
        }
    }

    private buildPre4Baskets() {
        this.pre4Baskets = new DrawingEuroPlayoffBaskets();
        this.pre4Baskets.championsLeagueBasket = new DrawingBasketDto();
        this.pre4Baskets.euroLeagueBasket = new DrawingBasketDto();
        this.pre4Baskets.conferenceLeagueBasket = new DrawingBasketDto();

        if (this.winnerDictionary[CONSTANTS.euroCupStages.playoff8]) {
            let winners = this.winnerDictionary[CONSTANTS.euroCupStages.playoff8];

            this.pre4Baskets.championsLeagueBasket = new DrawingBasketDto();
            this.pre4Baskets.championsLeagueBasket.basket1 = winners.championsLeagureWinners.basket1;
            this.pre4Baskets.championsLeagueBasket.basket2 = [];

            this.pre4Baskets.euroLeagueBasket = new DrawingBasketDto();
            this.pre4Baskets.euroLeagueBasket.basket1 =  winners.euroLeagureWinners.basket1;
            this.pre4Baskets.euroLeagueBasket.basket2 = [];

            this.pre4Baskets.conferenceLeagueBasket = new DrawingBasketDto();
            this.pre4Baskets.conferenceLeagueBasket.basket1 =  winners.confferrenceLeagureWinners.basket1;
            this.pre4Baskets.conferenceLeagueBasket.basket2 =  [];
        }
    }

    private buildPre2Baskets() {
        this.pre2Baskets = new DrawingEuroPlayoffBaskets();
        this.pre2Baskets.championsLeagueBasket = new DrawingBasketDto();
        this.pre2Baskets.euroLeagueBasket = new DrawingBasketDto();
        this.pre2Baskets.conferenceLeagueBasket = new DrawingBasketDto();

        if (this.winnerDictionary[CONSTANTS.euroCupStages.playoff4]) {
            let winners = this.winnerDictionary[CONSTANTS.euroCupStages.playoff4];

            this.pre2Baskets.championsLeagueBasket = new DrawingBasketDto();
            this.pre2Baskets.championsLeagueBasket.basket1 = winners.championsLeagureWinners.basket1;
            this.pre2Baskets.championsLeagueBasket.basket2 = [];

            this.pre2Baskets.euroLeagueBasket = new DrawingBasketDto();
            this.pre2Baskets.euroLeagueBasket.basket1 =  winners.euroLeagureWinners.basket1;
            this.pre2Baskets.euroLeagueBasket.basket2 = [];

            this.pre2Baskets.conferenceLeagueBasket = new DrawingBasketDto();
            this.pre2Baskets.conferenceLeagueBasket.basket1 =  winners.confferrenceLeagureWinners.basket1;
            this.pre2Baskets.conferenceLeagueBasket.basket2 =  [];
        }
    }

    private buildFinalBaskets() {

        this.finalBaskets = new DrawingEuroPlayoffBaskets();
        this.finalBaskets.championsLeagueBasket = new DrawingBasketDto();
        this.finalBaskets.euroLeagueBasket = new DrawingBasketDto();
        this.finalBaskets.conferenceLeagueBasket = new DrawingBasketDto();
        this.finalBaskets.championsLeagueBasket = new DrawingBasketDto();
        this.finalBaskets.euroLeagueBasket = new DrawingBasketDto();
        this.finalBaskets.conferenceLeagueBasket = new DrawingBasketDto();

        if (this.winnerDictionary[CONSTANTS.euroCupStages.playoff2]) {

            let winners = this.winnerDictionary[CONSTANTS.euroCupStages.playoff2];

            this.finalBaskets.championsLeagueBasket.basket1 = winners.championsLeagureWinners.basket1;
            this.finalBaskets.championsLeagueBasket.basket2 = [];

            this.finalBaskets.euroLeagueBasket.basket1 =  winners.euroLeagureWinners.basket1;
            this.finalBaskets.euroLeagueBasket.basket2 = [];

            this.finalBaskets.conferenceLeagueBasket.basket1 =  winners.confferrenceLeagureWinners.basket1;
            this.finalBaskets.conferenceLeagueBasket.basket2 = [];
        }
    }
}